import React from 'react';
import { NavLink } from 'react-router-dom';

import styles from '../app-launcher.module.css';

export const LauncherOverflow = ({ links, onNavigate }) => (
    <div className={styles.overflowList}>
        {links.map(link => (
            <NavLink className={styles.overflowItem} key={link.to} to={link.to} onClick={onNavigate}>
                {link.children}
            </NavLink>
        ))}
    </div>
);
